var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.to || '').startsWith('http'))?_c('a',{attrs:{"href":_vm.to,"target":"_blank"}},[_vm._t("default")],2):_c('n-link',{attrs:{"to":_vm.localePath(_vm.to)}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }